export const CONNECTOR_DASHBOARD_TABS_LIST_CLASS =
  "flex max-w-full items-center gap-0 overflow-x-auto border-b border-slate-200";

export const CONNECTOR_DASHBOARD_TABS_TRIGGER_CLASS =
  "group relative flex flex-none min-w-max cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap border-b-2 border-transparent px-4 py-2.5 text-center text-sm font-semibold text-slate-500 transition-colors data-[state=active]:border-[#026EEE] data-[state=active]:text-slate-900 hover:text-slate-800";

export const CONNECTOR_INNER_TABS_LIST_CLASS =
  "inline-grid max-w-full items-center gap-2 overflow-x-auto rounded-lg border-0 bg-[#F4F4F4] p-1.5";

export const CONNECTOR_INNER_TABS_TWO_COLUMNS_CLASS =
  `${CONNECTOR_INNER_TABS_LIST_CLASS} grid-cols-2`;

export const CONNECTOR_INNER_TABS_THREE_COLUMNS_CLASS =
  `${CONNECTOR_INNER_TABS_LIST_CLASS} grid-cols-3`;

export const CONNECTOR_INNER_TABS_TRIGGER_CLASS =
  "flex w-full min-w-max items-center justify-center rounded-lg border-0 px-4 py-2 text-center text-sm font-medium whitespace-nowrap text-slate-500 transition-colors data-[state=active]:bg-white data-[state=active]:font-semibold data-[state=active]:text-[#713D98] data-[state=active]:shadow-sm";
